module.exports = __webpack_public_path__ + "img/dombornyomas.fddb6964.jpg";